import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import axios from "axios";

import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  deleteDefaultSurveyRoomItemAction,
  getCommunincationAction,
  getDefaultSurveyRoomAction,
  getDefaultSurveyRooomItemAction,
  getSurveySetting,
  setCommunicationResponse,
  setDefaultSurveyRoomItemResponse,
  setDefaultSurveyRoomResponse,
  setDeleteDfaultSurveyRoomItemResponse,
  setSurveySettingResponse,
  setUpdateDefaultSurveyRoomItemResponse,
  setUpdateDefaultSurveyRoomResponse,
  updateCommunicationAction,
  updateDefaultSurveyRoomAction,
  updateDefaultSurveyRoomItemAction,
  updatedSurveySettingResponse,
  updateSurveySettingAction,
} from "../reducers/settingSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getSurveySettingSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/settings/survey`);
    if (res?.data) {
      yield put(setSurveySettingResponse(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateSurveySettingSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("Saga Payload:", payload);
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/settings/survey`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updatedSurveySettingResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(updatedSurveySettingResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getCommunincationSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/settings/communication`);
    if (res?.data) {
      yield put(setCommunicationResponse(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateCommunicationSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("Saga Payload:", payload);
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/settings/communication`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(updatedSurveySettingResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(updatedSurveySettingResponse(false));
  }
  yield put(setLoaderAction(false));
}

// setting survey
function* getDefaultSurveyRoomSaga(): any {
  yield put(setLoaderAction(true));
  try {
    const res = yield call<any>(callAPI, {}, "get", `client/settings/survey-default-rooms`);
    if (res?.data) {
      yield put(setDefaultSurveyRoomResponse(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateDefaultSurveyRoomSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("Saga Payload:", payload);
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "put",
      `client/settings/survey-default-rooms/${id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateDefaultSurveyRoomResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateDefaultSurveyRoomResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* getDefaultSurveyRooomItemSaga(payload: any): any {
  yield put(setLoaderAction(true));
  try {
     const {id} = payload?.payload;
    const res = yield call<any>(callAPI, {}, "get", `client/settings/survey-default-items?room_id=${id}`);
    if (res?.data) {
      yield put(setDefaultSurveyRoomItemResponse(res?.data));
    }
  } catch (error: any) {
    error?.response && handleError(error?.response, [401]);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

function* updateDefaultSurveyRoomItemSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("Saga Payload:", payload);
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      `client/settings/survey-default-items`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setUpdateDefaultSurveyRoomItemResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setUpdateDefaultSurveyRoomItemResponse(false));
  }
  yield put(setLoaderAction(false));
}

function* deleteDefaultSurveyRoomItemSaga(payload: any): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  try {
    console.log("Saga Payload:", payload);
    const {id} = payload?.payload;
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "delete",
      `client/settings/survey-default-items/${id}`
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setDeleteDfaultSurveyRoomItemResponse(true));
      yield put(setNotificationAction({ message: [], severity: "error" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
    yield put(setDeleteDfaultSurveyRoomItemResponse(false));
  }
  yield put(setLoaderAction(false));
}

export function* watchSetting() {
  yield takeLatest<any>(getSurveySetting, getSurveySettingSaga);
  yield takeLatest<any>(updateSurveySettingAction, updateSurveySettingSaga);
  yield takeLatest<any>(getCommunincationAction,getCommunincationSaga);
  yield takeLatest<any>(updateCommunicationAction,updateCommunicationSaga);
  yield takeLatest<any>(getDefaultSurveyRoomAction,getDefaultSurveyRoomSaga);
  yield takeLatest<any>(updateDefaultSurveyRoomAction,updateDefaultSurveyRoomSaga);
  yield takeLatest<any>(getDefaultSurveyRooomItemAction,getDefaultSurveyRooomItemSaga);
  yield takeLatest<any>(updateDefaultSurveyRoomItemAction,updateDefaultSurveyRoomItemSaga);
  yield takeLatest<any>(deleteDefaultSurveyRoomItemAction,deleteDefaultSurveyRoomItemSaga);

}
